module.exports = __webpack_public_path__ + "img/fssccert.5a160fcc.png";